/**
 * CDN image URLs for projects. Each project has:
 * - main: card/port image for project listing
 * - image1, image2, ...: content images in sequence for project detail
 */
export const IMAGE_URLS = {
  Aucto: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Aucto/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Aucto/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Aucto/image2.webp",
    image3: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Aucto/image3.webp",
    image4: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Aucto/image4.webp",
  },
  Canbiz: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Canbiz/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Canbiz/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Canbiz/image2.webp",
    image3: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Canbiz/image3.webp",
    image4: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Canbiz/image4.webp",
    image5: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Canbiz/image5.webp",
    image6: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Canbiz/image6.webp",
    image7: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Canbiz/image7.webp",
  },
  Dingg: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Dingg/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Dingg/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Dingg/image2.webp",
    image3: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Dingg/image3.webp",
    image4: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Dingg/image4.webp",
  },
  Elegancia: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elegancia/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elegancia/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elegancia/image2.webp",
  },
  Elriad: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/image2.webp",
    image3: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/image3.webp",
    image4: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/image4.webp",
    image5: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/image5.webp",
    image6: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/image6.webp",
    image7: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/image7.webp",
    image8: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/image8.webp",
    image9: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Elriad/image9.webp",
  },
  Kaashin: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Kaashin/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Kaashin/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Kaashin/image2.webp",
  },
  "My Loan": {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/My Loan/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/My Loan/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/My Loan/image2.webp",
    image3: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/My Loan/image3.webp",
  },
  Netgear: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Netgear/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Netgear/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Netgear/image2.webp",
    image3: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Netgear/image3.webp",
  },
  Ntradex: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Ntradex/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Ntradex/image1.webp",
  },
  pepsi: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/pepsi/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/pepsi/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/pepsi/image2.webp",
    image3: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/pepsi/image3.webp",
    image4: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/pepsi/image4.webp",
    image5: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/pepsi/image5.webp",
  },
  SCL: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/SCL/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/SCL/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/SCL/image2.webp",
  },
  Together: {
    main: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Together/main.webp",
    image1: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Together/image1.webp",
    image2: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Together/image2.webp",
    image3: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Together/image3.webp",
    image4: "https://cdn.jsdelivr.net/gh/ujjwalchouhan/Images@main/Images/optimized/Together/image4.webp",
  },
};
